/**
 * @param {object} user
 * @param {object} additional
 * @param {string[]} additional.permissions
 * @param {string} permission
 * @returns {boolean} - returns whether the user has the requested permission or not
 */
export const defaultHandler = (user, { permissions }, permission) => {
  const p = permission.toLowerCase();
  const index = p.lastIndexOf("_");
  const resource = p.slice(0, index);
  const action = p.slice(index + 1);

  return !!permissions.find((p) => p.resource === resource && p.action === action);
};

export const averroesUser = (user) => {
  return user.organization === "averroes";
};

export const averroesAdmin = (user) => {
  return user.organization === "averroes" && user.roles.includes("super_admin");
};
